<template>
  <div>
    <title-bar :title="$t('navigations.coupons')"/>
    <div v-if="this.rows" class="custom-table">
      <table-actions
        :actions="['addBtn', 'perPage']"
        :addBtnText="$t('messages.couponsAdd')"
        :addBtnLink="$helper.getAddUrl('coupon')"
        @onSearchInput="inputChange"
        @perPageChange="perPageChange"
        :defaultPerPage="perPage"
      />
      <table-lite
        :is-slot-mode="true"
        :is-loading="isLoading"
        :columns="columns"
        :rows="rows"
        :sortable="{}"
        @is-finished="isLoading = false"
      >

        <template v-slot:name="data">
          <router-link :to="$helper.getEditUrl('coupon', data.value.id)">
            {{ data.value.name }}
          </router-link>
        </template>
        <template v-slot:code="data">
          {{ data.value.code }}
        </template>
        <template v-slot:totalPrice="data">
          {{ data.value.totalPrice }}
        </template>
        <template v-slot:type="data">
          {{ $helper.getEnumTranslation('coupon_type', data.value.type, $i18n.locale) }}
        </template>
        <template v-slot:discountedValue="data">
          {{ data.value.discountedValue }}
        </template>
        <template v-slot:onOff="data">
          <b-badge :variant="statusClass(data.value.onOff)">
            {{ data.value.onOff ? $t('forms.enabled') : $t('forms.disabled') }}
          </b-badge>

        </template>
        <template v-slot:actions="data">
          <div class="just-buttons">
            <edit-btn :path="$helper.getEditUrl('coupon', data.value.id)"/>
            <delete-btn @pressDelete="deleteCoupon(data.value['@id'])"/>
          </div>
        </template>
      </table-lite>
      <table-pagination
        v-model="currentPage"
        :total="pages"
        :per-page="perPage"
        @input="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import {BBadge} from 'bootstrap-vue-3'
import TitleBar from "@/components/TitleBar.vue";
import TableLite from "vue3-table-lite";
import TablePagination from "@/components/Table/TablePagination.vue";
import TableActions from "@/components/Table/TableActions.vue";
import EditBtn from "@/components/Buttons/EditBtn.vue";
import DeleteBtn from "@/components/Buttons/DeleteBtn.vue";
import ResourceUtils from "@/mixins/ResourceUtils";
import {useToast} from "vue-toastification";
import Toast from "@/components/Toast";

export default {
  name: "AdminCustomersListing",
  components: {
    TableLite,
    TablePagination,
    TableActions,
    EditBtn,
    DeleteBtn,
    TitleBar,
    BBadge
  },
  mixins: [ResourceUtils],
  data() {
    return {
      search: "",
      isLoading: false,
      rows: null,
      perPage: this.$store.state.defaultPerPage,
      currentPage: 1,
      pages: 0,
      columns: [
        {
          label: this.$t('forms.name'),
          field: "name",
          sortable: false,
        },
        {
          label: this.$t('forms.code'),
          field: "code",
          sortable: false,
        },
        {
          label: this.$t('forms.value'),
          field: "type",
          sortable: false,
        },
        {
          label: this.$t('forms.discount'),
          field: "discountedValue",
          sortable: false,
        },
        {
          label: this.$t('forms.status'),
          field: "onOff",
          sortable: false,
        },
        {
          label: this.$t('forms.actions'),
          field: "actions",
          sortable: false,
          width: "120px",
        },
      ],
    };
  },
  created() {
    this.loadCoupons();
  },
  methods: {
    loadCoupons() {
      const params = {
        itemsPerPage: this.perPage,
        page: this.currentPage,
        'order[fromDate]': 'desc'
      };
      if (this.search && this.search.length) {
        params.search = this.search;
      }
      this.$Coupons.getCollection({params}).then((response) => {
        this.pages = response.data["hydra:totalItems"];
        this.rows = response.data["hydra:member"];
      });
    },
    onChangePage(page) {
      this.currentPage = page;
      this.loadCoupons();
    },
    statusClass(status) {
      let className = 'success'
      if (!status) {
        className = 'inactive'
      }
      return className
    },
    deleteCoupon(url) {
      this.$Coupons
        .deleteResourceByUrl({ url })
        .then((response) => {
          if (response.status === 204) {
            const toast = useToast();
            this.$helper.showToast(
              toast,
              Toast,
              this.$t('messages.couponDeleted'),
              "",
              "success"
            );
            this.loadCoupons();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$emit("clearAction");
            const toast = useToast();
            this.$helper.showToast(
              toast,
              Toast,
              error.response.data["hydra:title"],
              this.$t('messages.couponNotDeleted'),
              "danger"
            );
          }
        });
    },
    inputChange(value) {
      this.currentPage = 1;
      this.search = value;
      this.loadCoupons();
    },
    perPageChange(num) {
      this.currentPage = 1;
      this.perPage = num;
      this.loadCoupons();
    },
    onPageChange() {
      this.loadCoupons();
    },

  },
};
</script>

<style lang="scss">
</style>
